export default __webpack_public_path__ + "static/media/copiar.6f3d2021.svg";